import { commissionActionTypes as actions } from '~constants/actionTypes';
import { pmsEndpoints } from '~settings/endpoints';
import { fetch } from '~actions/pms-actions/shared';
import * as queries from '~settings/pms-queries';
import { message } from 'antd';
import i18n from '~settings/i18n';
import { formatSimpleParams } from '~helpers/params';

export const createCommission = params => dispatch => {
  fetch({
    dispatch,
    endpoint: pmsEndpoints.commissionModal.url(),
    params: queries.createCommission(
      formatSimpleParams(
        {
          name: null,
          bonus: false,
          bookingCountFrom: null,
          bookingCountTo: null,
          capType: null,
          capValue: null,
          category: null,
          checkInDateFrom: null,
          checkInDateTo: null,
          convertedCalculationValue: null,
          description: null,
          effectiveFrom: null,
          effectiveTo: null,
          fullyCalculatable: null,
          listingId: null,
          propertyId: null,
          retrospectiveCommission: null,
          tenancyLengthFrom: null,
          tenancyLengthTo: null,
          tenancyUnit: null,
          type: null,
          value: null,
        },
        params,
      ),
    ),
    communicationType: actions.CREATE_CS,
    onError: () => {
      message.error(i18n.t('cms:cms.properties.edit.toast.error'));
    },
    onSuccess: () => {
      message.success(i18n.t('cms:cms.property.commission.create_success.tips'));
    },
  });
};

export const updateCommission = params => dispatch => {
  fetch({
    dispatch,
    endpoint: pmsEndpoints.commissionModal.url(),
    params: queries.updateCommission(params),
    communicationType: actions.UPDATE_CS,
    onError: () => {
      message.error(i18n.t('cms:cms.properties.edit.toast.error'));
    },
    onSuccess: () => {
      message.success(i18n.t('cms:cms.property.commission.update_success.tips'));
    },
  });
};

export const deleteCommission = params => dispatch => {
  fetch({
    dispatch,
    endpoint: pmsEndpoints.commissionModal.url(),
    params: queries.deleteCommission(params),
    communicationType: actions.DELETE_CS,
    onError: () => {
      message.error(i18n.t('cms:cms.properties.edit.toast.error'));
    },
    onSuccess: () => {
      message.success(i18n.t('cms:cms.property.commission.delete_success.tips'));
    },
  });
};

export const setPropertyCommissionTiers = data => ({
  type: actions.SET_PROPERTY_COMMISSION_TIERS_CS,
  data: data.property,
});

export const getPropertyCommissionTiers =
  (slug, successCallback = () => {}) =>
  dispatch => {
    fetch({
      dispatch,
      endpoint: pmsEndpoints.commissionModal.url(),
      params: queries.getPropertyCommissionTiers({ slug }),
      communicationType: actions.GET_PROPERTY_COMMISSION_TIERS_CS,
      successAction: setPropertyCommissionTiers,
      onSuccess: res => {
        successCallback(res);
      },
      onError: () => {
        message.error(i18n.t('cms:cms.properties.edit.toast.error'));
      },
    });
  };
